<template>
  <b-sidebar
    :id="id"
    v-model="localVisible"
    right
    shadow
    backdrop
    no-header-close
    :class="['grc-form-sidebar', `grc-form-sidebar--${size}`]"
    :style="sidebarStyle"
    @hidden="onHidden"
  >
    <template #header>
      <div class="grc-form-sidebar__header">
        <div class="grc-form-sidebar__title-wrapper">
          <slot name="title">
            <span class="grc-form-sidebar__title">{{ title }}</span>
          </slot>
        </div>
        <b-button
          size="sm"
          variant="link"
          class="grc-form-sidebar__close"
          aria-label="Fechar painel"
          @click="closeSidebar"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </b-button>
      </div>
    </template>

    <div :class="['grc-form-sidebar__body', bodyClass]">
      <slot></slot>
    </div>
  </b-sidebar>
</template>

<script>
export default {
  name: "GRCFormSidebar",
  props: {
    bodyClass: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "grc-form-sidebar",
    },
    size: {
      type: String,
      default: "wide",
      validator(value) {
        return ["compact", "wide"].includes(value);
      },
    },
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localVisible: this.visible,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        "--grc-sidebar-width": this.resolvedWidth,
      };
    },
    resolvedWidth() {
      if (this.width) {
        return this.width;
      }

      return this.size === "compact" ? "50vw" : "75vw";
    },
  },
  watch: {
    visible(newValue) {
      this.localVisible = newValue;
    },
    localVisible(newValue) {
      this.$emit("update:visible", newValue);
    },
  },
  methods: {
    closeSidebar() {
      this.localVisible = false;
    },
    onHidden() {
      this.$emit("hidden");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
::v-deep .b-sidebar {
  width: var(--grc-sidebar-width, 75vw) !important;
  max-width: var(--grc-sidebar-width, 75vw) !important;
}

::v-deep .b-sidebar-header {
  padding: 0;
}

::v-deep .b-sidebar-body {
  padding: 0;
}

.grc-form-sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 72px;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e9ecef;
  background: #fff;
}

.grc-form-sidebar__title-wrapper {
  flex: 1;
  min-width: 0;
  padding-right: 1rem;
}

.grc-form-sidebar__title {
  display: block;
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
  line-height: 1.4;
}

.grc-form-sidebar__close {
  color: #6c757d;
  text-decoration: none;
}

.grc-form-sidebar__close:hover,
.grc-form-sidebar__close:focus {
  color: #212529;
}

.grc-form-sidebar__body {
  height: 100%;
  padding: 1.25rem;
  overflow-y: auto;
  background: #fff;
}

@media (max-width: 1199.98px) {
  ::v-deep .b-sidebar {
    width: 85vw !important;
    max-width: 85vw !important;
  }
}

@media (max-width: 767.98px) {
  ::v-deep .b-sidebar {
    width: 100vw !important;
    max-width: 100vw !important;
  }

  .grc-form-sidebar__header,
  .grc-form-sidebar__body {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
